// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uKD4","index":"styles_index__277wV"};